<!-- Hero Section -->
<div class="container">
  <div class="d-lg-flex position-relative">
    <div style="min-height: 700px" class="container d-lg-flex align-items-lg-center space-top-2 space-top-md-5 space-lg-0 ">
      <!-- Content -->
      <div class="row w-100">
        <div class="col-lg-5">
          <h1 class="display-4 font-size-md-down-5 font-weight-medium mb-3">Live streaming</h1>        <p>
          <!--          Planning a conference can be a daunting task. From finding the right venue to coordinating with vendors, there are many moving parts to consider.-->
          <br>
          Live streaming doesn't need to cost a fortune. Use our proprietary technology to simplify your hybrid events at a fraction of the cost.
        </p>

          <div class="d-flex align-items-center flex-wrap">
            <button class="btn btn-primary btn-wide transition-3d-hover" type="button" (click)="ctaService.showCTA('17e74dcb-2609-478e-848a-ceffdd2c4df2')">Get a Quote</button>
            <!-- Fancybox -->

            <!-- End Fancybox -->
          </div>
        </div>
      </div>
      <!-- End Content -->

      <!-- SVG Background -->
      <div id="SVGMainHero" class="col-lg-9 col-xl-7  d-none d-lg-block position-absolute top-0 right-0 pr-0" style="margin-top: 50px;">
        <figure class="ie-main-hero text-right">
          <img class="img-fluid" src="../../assets/website/live-streaming-hero.png" alt="Image Description">
        </figure>
      </div>
      <!-- End SVG Background -->
    </div>
  </div>
</div>
<!-- End Hero Section -->


<!-- Features Section -->
<div class="container space-2">
  <div class="row justify-content-lg-between align-items-lg-center">
    <div class="col-lg-5 order-lg-2 mb-9 mb-lg-0">
      <!-- Description -->
      <h2 class="font-weight-medium">The OkWhen StreamCase</h2><h4>Plug-n-play streaming for any budget.</h4>
      <p>A self-contained streaming box that can be deployed to any event and remote-controlled by our team. Reduce labor costs and increase quality!</p>
      <!-- End Description -->

      <!-- List -->
      <ul class="list-unstyled text-secondary">
        <li class="media my-3">
          <div class="d-flex mt-1 mr-2">
            <span class="fas fa-check text-success"></span>
          </div>
          <div class="media-body">
            Easy to ship and setup
          </div>
        </li>
        <li class="media my-3">
          <div class="d-flex mt-1 mr-2">
            <span class="fas fa-check text-success"></span>
          </div>
          <div class="media-body">
            Plug it in and we configure the rest
          </div>
        </li>
        <li class="media my-3">
          <div class="d-flex mt-1 mr-2">
            <span class="fas fa-check text-success"></span>
          </div>
          <div class="media-body">
            Stream up to 14 rooms at the same time!
          </div>
        </li>
      </ul>
      <!-- End List -->
    </div>

    <div class="col-lg-7 order-lg-1">
      <!-- SVG Shape -->
      <figure id="SVGgetAnswered" class=" ie-get-answered">
        <img class="js-svg-injector" src="../../assets/website/streamcase.png" alt="Image Description"
             data-parent="#SVGgetAnswered">
      </figure>
      <!-- End SVG Shape -->
    </div>
  </div>
</div>
<!-- End Features Section -->


<!-- Hero Section -->
<div id="SVGheroSectionBg" class=" position-relative gradient-half-primary-v3">
  <div class="container space-2">
    <div class="row align-items-lg-center">
      <div class="col-lg-5 mb-7 mb-lg-0">
        <!-- Info -->
        <h1 class="mb-4">We create the best <span class="text-primary font-weight-semi-bold">solution</span> for you.</h1>
        <p>Front is an easy-to-use template that is loaded with all the features you will ever need.</p>
        <!-- End Info -->
      </div>

      <div class="col-lg-7">
        <!-- SVG Icon -->
        <figure class="ie-working-men">
          <img class="js-svg-injector" src="../../assets/svg/illustrations/working-men.svg" alt="Image Description"
               data-parent="#SVGheroSectionBg">
        </figure>
        <!-- End SVG Icon -->
      </div>
    </div>
  </div>

  <!-- SVG Background -->
  <figure class="position-absolute right-0 bottom-0 left-0">
    <img class="js-svg-injector" src="../../assets/svg/components/wave-1-bottom-sm.svg" alt="Image Description"
         data-parent="#SVGheroSectionBg">
  </figure>
  <!-- End SVG Background Section -->
</div>
<!-- End Hero Section -->

